import type { StaticSensorReadings } from '@/models/types/plc/static-sensor-readings'
import type { DatiSensoreStaticoDTO } from '../../dto/plc/dati-sensore-statico-dto'
import { mapToSensoreStaticoDTO, mapToStaticSensorReading } from './static-sensor-reading-mapper'

const mapToStaticSensorReadings = (dto: DatiSensoreStaticoDTO): StaticSensorReadings => {
    return {
        isAggregated: dto.isAggregated,
        readings: dto.datas?.map((reading) => mapToStaticSensorReading(reading)) ?? [],
    }
}

const mapToDatiSensoreStaticoDTO = (sensor: StaticSensorReadings): DatiSensoreStaticoDTO => {
    return {
        isAggregated: sensor.isAggregated,
        datas: sensor.readings.map((reading) => mapToSensoreStaticoDTO(reading)),
    }
}

export { mapToDatiSensoreStaticoDTO, mapToStaticSensorReadings }
